import React, { useState, useRef, useEffect } from "react"
import { useForm } from "react-hook-form"

import ReCAPTCHA from "react-google-recaptcha"
import AuthService from "../../../shared/services/authentication"
import RegisterService from "../../../shared/services/register"
import Button from "../../../shared/components/atoms/Button/Button"
import BtnWhatsapp from "../../../shared/components/atoms/btn-whatsapp/btn-whatsapp"
import Select from "../../../shared/components/atoms/select-material/select-material"
import Input from "../../../shared/components/atoms/input-material/input-material"
import ModalRegister from "../../../shared/components/organisms/register-modal/register-modal"
import Radio from "../../../shared/components/atoms/radio-login/radio"
import useDocument from "../../../shared/hooks/useDocument"
import OtpInput from "../../../shared/components/atoms/otp-input/otp-input"
import { siteUrl } from "../../../shared/state/utils/site-url"
import {
  EMAIL_PATTERN,
  NUMBER_PATTERN,
} from "../../../shared/state/constants/appConstants"
import {
  censorCellPhone,
  censorMail,
} from "../../../shared/state/utils/utilities-string"
import "./modal-otp-recover.scss"
import useBrowserMode from "../../../shared/hooks/useBrowserMode"
import useMobileMode from "../../../shared/hooks/useMobileMode"

const ModalOtpRecover = ({ onSuccessAuth, onClose, hideModal }) => {
  const { isBrowser } = useBrowserMode();
  let windowValidation = isBrowser && true;
  const [method, setMethod] = useState("DOCUMENT")
  const [step, setStep] = useState( windowValidation && localStorage.getItem("stepRecoveryPassword") ? parseInt(localStorage.getItem("stepRecoveryPassword"))  : 0)
  const [isLoading, setIsLoading] = useState(false)
  const [disbleDocument, setDisableDocument] = useState()
  const [userInfo, setUserInfo] = useState(null)
  const [code, setCode] = useState()
  const [errorOtp, setError] = useState()
  const [resendCodeSucess, setResendCodeSucess] = useState()
  const {
    register,
    errors,
    control,
    handleSubmit,
    setValue,
    setError: setErrorForm,
    clearError,
  } = useForm()
  const document = useDocument()
  const recaptchaRef = useRef()
  const { isMobile } = useMobileMode()

  const onSubmit = values => {
    if (step === 0) {
      handleSendCode(values)
    } else {
      verifyCode(code)
    }
  }

  const handleSendCode = async values => {
    try {
      setIsLoading(true)
      if (method === "DOCUMENT") {
        const user = await getUserByDocument(
          values.primary,
          values.documentType
        )
        setDisableDocument(true)
        setUserInfo(user)
        localStorage.setItem("userEmail", user)
        setMethod("EMAIL")
        setValue("primary", censorMail(user.email))
      } else if (method === "EMAIL") {
        await sendTemporalPassword(userInfo?.email || values.primary)
        setUserInfo({ email: userInfo?.email || values.primary })
        localStorage.setItem("userEmail", JSON.stringify(userInfo?.email || values.primary))
        setStep(1)
      } else if (method === "CELLPHONE") {
        if (userInfo !== null) {
          await sendTemporalPassword(userInfo?.email)
          localStorage.setItem("userEmail", userInfo?.email)
          setStep(1)
        } else {
          const email = await getUserByCellphone(values.primary)
          await sendTemporalPassword(email)
          setUserInfo({ email: email })
          localStorage.setItem("userEmail", JSON.stringify(email))
          setStep(1)
        }
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  const verifyCode = async code => {
    windowValidation && localStorage.getItem("userEmail") ? setUserInfo(localStorage.getItem("userEmail")) : "";
    let userEmailFormat = windowValidation ? localStorage.getItem("userEmail").replace(/['"\\]+/g, "") : null
 
    try {
      setIsLoading(true)
      const res = await AuthService.loginUser({
        email: userInfo?.email ||  userEmailFormat,
        captcha: recaptchaRef.current.getValue(),
        password: code,
        type: "EMAIL",
      })
      if (res.status === 200) {
        setStep(2)
        localStorage.setItem("stepRecoveryPassword", 2)
        onSuccessAuth({
          token: res.data.tokenData.accessToken,
          code,
          idToken: res.data.tokenData.idToken,
        })
      } else {
        setError("El código es incorrecto")
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  const handleBackButton = () => {
    if (step === 0 && !disbleDocument) {
      window.location.href = siteUrl + "/autenticacion"
    } else if (step === 0 && disbleDocument) {
      setValue("primary", "")
      setUserInfo(null)
      setDisableDocument(false)
    } else {
      setValue("primary", "")
      setUserInfo(null)
      setDisableDocument(false)
      setStep(0)
    }
  }

  const getUserByCellphone = async cellPhone => {
    const res = await RegisterService.checkPhone({
      cellPhone: process.env.COUNTRY_PHONE_PREFIX + cellPhone,
    })
    if (res.status === 400) {
      return res.data.email
    } else {
      setErrorForm(
        "primary",
        "api-validation",
        "El número de documento no se encuentra registrado"
      )
      throw new Error("El número de celular no se encuentra registrado ")
    }
  }

  const sendTemporalPassword = async email => {
    const res = await AuthService.recoveryPassword(email)
    if (res.status === 200) {
      return res
    } else {
      setErrorForm("primary", "api-validation", res.userMessage)
      throw new Error(res.userMessge)
    }
  }

  const getUserByDocument = async (document, documentType) => {
    const res = await RegisterService.checkDocument({
      typeId: documentType,
      numberId: document,
      userId: null,
    })
    if (res.status === 400) {
      return { cellPhone: res.data.cellPhone, email: res.data.email }
    } else {
      console.log("test")
      setErrorForm(
        "primary",
        "api-validation",
        "El número de documento no se encuentra registrado"
      )
      throw new Error("El número de documento no se encuentra registrado ")
    }
  }

  return (
    <ModalRegister
      onClose={onClose}
      title="Recuperar tu contraseña"
      description={
        step === 0 ? (
          <>
            Ahora te invitamos a seleccionar el medio por donde quieres
            verificar el cambio de contraseña:
          </>
        ) : (
          <>
            Te hemos enviado un código de 6 dígitos como mensaje al medio
            seleccionado en el paso anterior.
          </>
        )
      }
    >
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey="6LdO87YUAAAAADiKJPkEhXpUH7_JthcTOF1iVMnx"
      />
      <div className="f-recover-otp">
        {step === 0 && (
          <div className="f-radio-container">
            {process.env.LOCALE !== "es-PR" && !disbleDocument && (
              <Radio
                id="radio-recovery-document"
                checked={method === "DOCUMENT"}
                label="Documento de identidad"
                onChange={() => {
                  if (!disbleDocument) {
                    setValue("primary", "")
                  }
                  clearError("primary")
                  setMethod("DOCUMENT")
                }}
              />
            )}
            <Radio
              id="radio-recovery-email"
              checked={method === "EMAIL"}
              label="Correo"
              onChange={() => {
                if (!disbleDocument) {
                  setValue("primary", "")
                }
                if (userInfo) {
                  setValue("primary", censorMail(userInfo.email))
                } else {
                  setValue("")
                }
                clearError("primary")
                setMethod("EMAIL")
              }}
            />
            <Radio
              label="Celular"
              id="radio-recovery-cellphone"
              checked={method === "CELLPHONE"}
              onChange={() => {
                if (!disbleDocument) {
                  setValue("primary", "")
                }
                if (userInfo) {
                  setValue("primary", censorCellPhone(userInfo.cellPhone))
                } else {
                  setValue("")
                }
                clearError("primary")
                setMethod("CELLPHONE")
              }}
            />
          </div>
        )}

        <form className="f-form-recover" onSubmit={handleSubmit(onSubmit)}>
          {step === 0 && (
            <>
              {" "}
              {method === "DOCUMENT" && (
                <Select
                  errors={errors}
                  label="Documento de identidad"
                  control={control}
                  name="documentType"
                  items={document.tipoDeDocumento.map(({ name }) => ({
                    key: name,
                    value: name,
                  }))}
                  rules={{
                    validate: value => {
                      if (method === "DOCUMENT") {
                        if (!value) return "Este campo es requerido"
                      }
                      return true
                    },
                  }}
                />
              )}
              <Input
                errors={errors}
                disabled={userInfo !== null}
                label={
                  method === "DOCUMENT"
                    ? document.inputNumeroDeDocumento
                    : method === "EMAIL"
                    ? "Correo electrónico *"
                    : "Número de celular *"
                }
                name="primary"
                register={register({
                  validate: value => {
                    if (method === "DOCUMENT") {
                      if (!value) {
                        return "El documento es requerido."
                      }
                      if (value.length < 5) {
                        return "El documento debe tener mínimo 5 caracteres."
                      }
                      if (value.length > 15) {
                        return "El documento debe tener máximo 15 caracteres."
                      }
                      if (!value.match(NUMBER_PATTERN)) {
                        return "Ingresa sólo números."
                      }
                    } else if (method === "CELLPHONE") {
                      if (!value) {
                        return "Tu número celular es requerido."
                      }
                      if (!value.match(NUMBER_PATTERN) && !userInfo?.email) {
                        return "Ingresa sólo números."
                      }
                      if (value.length !== parseInt(process.env.CELL_DIG)) {
                        return `Un número celular debe tener ${process.env.CELL_DIG} dígitos.`
                      }
                    } else if (method === "EMAIL") {
                      if (!value) {
                        return "El correo es requerido."
                      }
                      if (value.length < 8) {
                        return "Este campo debe contener por lo menos 8 dígitos."
                      }
                      if (value.length > 50) {
                        return "Este campo debe contener máximo 50 dígitos."
                      }
                      if (!EMAIL_PATTERN.test(value)) {
                        return "Correo inválido"
                      }
                    }
                    return true
                  },
                })}
              />
            </>
          )}

          {step === 1 && (
            <div className="f-otp-step">
              <OtpInput
                is
                onChange={value => {
                  if (setError) {
                    setError(null)
                  }
                  setCode(value)
                  setResendCodeSucess(false)
                  if (value.length === 6) {
                    verifyCode(value)
                  }
                }}
              />

              {errorOtp && <p className="f-otp-error">{errorOtp} </p>}
              <p className="f-otp-step__resend">
                ¿No recibiste un código? <br />
                <button
                  onClick={e => {
                    e.preventDefault()
                    handleSendCode(code)
                    setError()
                    setResendCodeSucess(true)
                  }}
                >
                  Reenviar código
                </button>
              </p>
              {resendCodeSucess && (
                <p className="f-otp-resend-success">
                  El código se ha reenviado correctamente 
                </p>
              )}
            </div>
          )}
          <div className="f-btn-container-resend">
            <Button
              type="button"
              text="ATRAS"
              isEnabled={isLoading}
              classname="f-button f-button--secondary"
              onClickAction={handleBackButton}
            />
            <Button
              text="SIGUIENTE"
              classname="f-button f-button--primary "
              isEnabled={isLoading}
            />
          </div>
          <BtnWhatsapp onClick={() => {
            if (!isMobile) {
              hideModal();
              localStorage.setItem("stepRecoveryPassword", step)
            }
          }} />
        </form>
      </div>
    </ModalRegister>
  )
}

export default ModalOtpRecover
